import PageFactory from '../PageFactory';
import NotFoundIllustration from './NotFoundIllustration';

const NotFound = ({ hideControls = false }: { hideControls?: boolean } = {}): React.ReactNode =>
  PageFactory(
    NotFoundIllustration,
    "Can't Find That",
    ["The page or resource you're trying to access might not be available or doesn't exist"],
    hideControls
  );

export default NotFound;
